export default {
  data() {
    return {
      entity_code: this.$route.meta.entity,
      role_code: this.$route.meta.role,
      permission_code: this.$route.meta.permission
    };
  },
  computed: {
    module_name: function () {
      return (
        this.user_entity_types
          .map(
            entity_type =>
              entity_type.roles.find(role => role.code === this.role_code)
                ?.permissions ?? []
          )
          .flat()
          .find(permission => permission.code === this.permission_code).name ??
        ""
      );
    },
    route_name_prefix: function () {
      return routeNamePrefix(this.entity_code, this.role_code, this.permission_code);
    }
  },
  methods: {
    routeName: function (route_name, prefix = null) {
      prefix = prefix || this.route_name_prefix;
      return routeName(route_name, prefix);
    },
  }
};

export const routeName = function (route_name, prefix) {
  return [prefix, route_name, 'path'].filter(item => item).join('_');
}

export const routeNamePrefix = function (entity_code, role_code, permission_code) {
  return `${entity_code}_${role_code}_${permission_code}`;
}

export const routeMetaObject = function (entity_code, role_code, permission_code) {
  return {
    entity: entity_code,
    role: role_code,
    permission: permission_code,
  };
}

export const routerUtilities = function ({entity, role, permission}) {
  let route_name_prefix = routeNamePrefix(entity, role, permission);
  const META = routeMetaObject(entity, role, permission)
  let routeNameToRouter = (route_name) => { return routeName(route_name, route_name_prefix) }
  return [META, routeNameToRouter]
}
